import { useCallback, useEffect, useState } from "react";
import httpClient from "../../../utilis/jwtRequest";
import BErrorIndicator from "../../../components/indicators/BErrorIndicator";
import BLoadingIndicator from "../../../components/indicators/BLoadingIndicator";
import BNoDataIndicator from "../../../components/indicators/BNoDataIndicator";
import BTable from "../../../components/tables/BTable";
import { ORDER_WAY } from "../../../components/constants/componentsConstants";
import { useParams } from "react-router";

function UserMessagesPage() {
  const [pageSize, setPageSize] = useState(20);
  const [nmbOfRecords, setNmbOfRecords] = useState(20);
  const [page, setPage] = useState(1);
  const [resources, setResources] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [ordering, setOrdering] = useState([]);
  const [availableWidth, setAvailableWidth] = useState(0);
  const availableOptions = [10, 15, 20, 40];
  const params = useParams();
  const [noRecords, setNoRecords] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    setError(false);
    httpClient
      .get(`/Users/${params.id}/chats`)
      .then((res) => {
        if (res.data[0] == undefined) {
          setNoRecords(true);
          return;
        }
        setResources(res.data[0].messages);
        setNmbOfRecords(res.data[0].count);
      })
      .catch((err) => {
        setError(true);
      })
      .finally((_) => {
        setIsLoading(false);
      });
  }, []);



  const child = useCallback((node) => {
    if (node !== null) {
      setAvailableWidth(node.getBoundingClientRect().width);
    }
  });

  const addOrdering = (field) => {
    let tempOrdering = [...ordering];
    field = field.replace(/([A-Z])/g, "_$1").toLowerCase();
    let orderState;

    if(tempOrdering.includes(field)) {
      const idx = tempOrdering.indexOf(field);
      tempOrdering[idx] = `-${field}`;
      orderState = ORDER_WAY.decrease;
    }
    else if(tempOrdering.includes(`-${field}`)) {
      const idx = tempOrdering.indexOf(`-${field}`);
      tempOrdering.splice(idx, 1);
      orderState = ORDER_WAY.default;
    }
    else{
      tempOrdering.push(field);
      orderState = ORDER_WAY.increase;
    }
    setOrdering(tempOrdering);
    setPage(1);
    return orderState;
  };

  if (isLoading) {
    return <BLoadingIndicator />;
  } else if (error) {
    return <BErrorIndicator />;
  }

  if (noRecords) {
    return <BNoDataIndicator/>
  }

  return (
    <div ref={child} className="p-6">
      <BTable
        data={resources}
        header="Messages"
        availableOptions={availableOptions}
        setPageSize={setPageSize}
        pageSize={pageSize}
        addOrdering={addOrdering}
        title="Messages"
        ordering={ordering}
        availableWidth={availableWidth}
        isCustomerPage={true}
        maxNmbOfChars={1000}
      />
    </div>
  );
}

export default UserMessagesPage;
